import QueryString from './QueryString';

export default function loginPath({ pathname, search = '', source, workspace }) {
  // QueryString percent-encodes values, so the target goes in raw — the login screen decodes it once.
  const params = new QueryString({ redirect: `${pathname}${search}`, source, workspace });
  return `/login${params.toString(true)}`;
}
